{
  "HOST": "https://multiregion-promote-service.rcf-prod.nikecloud.com",
  "HOST_DELEDGE": "https://deledge.prod.commerce.nikecloud.com",
  "HOST_STORE_LOCATIONS": "https://api.nike.com",
  "oktaAuthorizeResource" : "/v1/prod/authorize",
  "oktaTokenResource": "/v1/prod/token",
  "HOST_STORE_VIEWS": "https://storeviews-regional-us-east-1.risedomain-prod.nikecloud.com"
}
